export default "__VITE_ASSET__Dc0l_MCh__"